import { pushToDataLayer } from "components/front/layout/GoogleTagManager";

const pageView = (): void => pushToDataLayer({ event: "pageview" });
export default pageView;
